module.exports = __webpack_public_path__ + "static/img/gift-8.042c99e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/winter-camp/assets/gift-8.png
// module id = 368
// module chunks = 140